import { render, staticRenderFns } from "./SocialSettings.vue?vue&type=template&id=ac22e0ae&scoped=true"
import script from "./SocialSettings.vue?vue&type=script&lang=js"
export * from "./SocialSettings.vue?vue&type=script&lang=js"
import style0 from "./SocialSettings.vue?vue&type=style&index=0&id=ac22e0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac22e0ae",
  null
  
)

export default component.exports